const toYesNo = (val) =>
  val === true || val === "1" ? "Yes" :
  val === false || val === "0" ? "No" : "";

export const CorporateStructureFactory = (details = {}) => {
  console.log("CorporateStructureFactory", details);
    let UBOS = [];
    if (details.ubos) {
      if (typeof details.ubos === "string") {
        UBOS = JSON.parse(details.ubos);
      } else if (Array.isArray(details.ubos)) {
        UBOS = details.ubos;
      }
    } else if (details.uboState) {
      if (typeof details.uboState === "string" ) {
        UBOS = JSON.parse(details.uboState);
        // if UBOS not array
        if (!Array.isArray(UBOS)) {
          UBOS = [UBOS];
        }
      } else if (Array.isArray(details.uboState)) {
        UBOS = details.uboState;
      }
    } else {
      UBOS = [];
    }

    return {
      certifiedStructureChart: toYesNo(details.certifiedStructureChart),
      outstandingConcern: toYesNo(details.concernsRegardingStructure),
      concernDetails: details.concernsDetails || null,
      mlnoNotified: toYesNo(details.mlnoNotified),
      isUbo25Identified: toYesNo(details.isUbo25Identified),
      isUboIdentified: toYesNo(details.uboIdentified),
      ubos: UBOS,
      whyUboNotIdentified: details.reasonForNotIdentifying || details.whyUboNotIdentified || null,
      managedByOne: toYesNo(details.managedByOne),
      threeYearUKAccount: toYesNo(details.filedThreeYearsAccounts),
      wellKnownUKCompany: toYesNo(details.knownUKCompany),
      status: details.status || "Not Validated",
    };
  };
  